import { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { IconNames } from '@cobliteam/ui/icons';
import type { SemanticKey } from '@cobliteam/ui/theme/tokens/variants/sharedVariants';

const statusIconName: Record<DeviceGeneralStatus, IconNames | null> = {
  [DeviceGeneralStatus.Normal]: 'cb-signal-cellular-4',
  [DeviceGeneralStatus.Syncing]: 'rotate-cw',
  [DeviceGeneralStatus.NoSignal]: 'cb-signal-cellular-off',
  [DeviceGeneralStatus.Disconnected]: 'unplug',
  [DeviceGeneralStatus.Unavailable]: 'triangle-alert',
  [DeviceGeneralStatus.NoSufficientData]: 'database',
  [DeviceGeneralStatus.LosingData]: 'activity',
  [DeviceGeneralStatus.InDevolution]: 'undo-2',
  [DeviceGeneralStatus.Damaged]: 'wrench',
};

const statuscolor: Record<DeviceGeneralStatus, SemanticKey> = {
  [DeviceGeneralStatus.Normal]: 'primary',
  [DeviceGeneralStatus.Syncing]: 'primary',
  [DeviceGeneralStatus.NoSignal]: 'default',
  [DeviceGeneralStatus.Disconnected]: 'warning',
  [DeviceGeneralStatus.Unavailable]: 'danger',
  [DeviceGeneralStatus.NoSufficientData]: 'default',
  [DeviceGeneralStatus.LosingData]: 'danger-dark',
  [DeviceGeneralStatus.InDevolution]: 'purple',
  [DeviceGeneralStatus.Damaged]: 'danger',
};

const statusLabel: Record<DeviceGeneralStatus, string> = {
  [DeviceGeneralStatus.Normal]: 'normal',
  [DeviceGeneralStatus.Syncing]: 'sincronizando',
  [DeviceGeneralStatus.NoSignal]: 'sem sinal',
  [DeviceGeneralStatus.Disconnected]: 'desconectado',
  [DeviceGeneralStatus.Unavailable]: 'indisponível',
  [DeviceGeneralStatus.NoSufficientData]: 'sem dados suficientes',
  [DeviceGeneralStatus.LosingData]: 'perdendo dados',
  [DeviceGeneralStatus.InDevolution]: 'em devolução',
  [DeviceGeneralStatus.Damaged]: 'danificado',
};

const tooltipLabel: Record<DeviceGeneralStatus, string> = {
  [DeviceGeneralStatus.Normal]: 'O dispositivo está saudável e mostrando informações mais recentes',
  [DeviceGeneralStatus.Syncing]: 'O dispositivo está saudável e novas informações estão sendo descarregadas no painel',
  [DeviceGeneralStatus.NoSignal]:
    'As informações sobre o veículo estão desatualizadas mas o dispositivo continua registrando dados enquanto estabiliza para sincronizá-los com o painel',
  [DeviceGeneralStatus.Disconnected]: 'O dispositivo foi retirado do veículo. A última tensão da bateria do veículo registrada pelo dispositivo está abaixo dos 10V',
  [DeviceGeneralStatus.Unavailable]: 'Não recebemos atualização há mais de 72 horas e algumas ações precisam ser tomadas',
  [DeviceGeneralStatus.NoSufficientData]: 'Dispositivo sem dados suficientes',
  [DeviceGeneralStatus.LosingData]: 'Dispositivo rodando sem veículo associado e perdendo dados',
  [DeviceGeneralStatus.InDevolution]: 'Dispositivo em processo de devolução',
  [DeviceGeneralStatus.Damaged]:
    'Através de diagnósticos remotos e automáticos feitos nos dispositivos conseguimos identificar quando há uma quantidade de mensagens inválidas que inviabilizam o seu uso',
};

const getStatusContent = (status: DeviceGeneralStatus) => {
  const iconName = statusIconName[status];
  const color = statuscolor[status];
  const label = statusLabel[status];
  const tooltip = tooltipLabel[status];

  return {
    iconName,
    color,
    label,
    tooltip,
  };
};

export default getStatusContent;
